




import { Component, Prop, Vue } from "vue-property-decorator";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import StudentCategoriesForm from "@/views/Configuration/StudentCategories/StudentCategoriesForm.vue";
import { IStudentCategory } from "@/interfaces/IStudentCategory";

@Component({
  components: {
    FscSimpleCard,
    StudentCategoriesForm,
  },
})
export default class StudentCategoryCreate extends Vue {
  public name = "StudentCategoryCreate";

  public category = {
    id: 0,
    name: "",
    abbreviation: "",
    textColorHex: "",
    backgroundColorHex: "",
    archived: false,
  };

  @Prop({ type: Boolean, required: false, default: () => false })
  public isLoading!: boolean;

  public onStudentCategoryCreate(category: IStudentCategory): void {
    this.$emit("category-create", category);
  }

  public onStudentCategoryAbortCreate(): void {
    this.$emit("category-abort");
  }
}
